/* KAMOK_ACCESSIBILITY_MENU_20260726 */
(() => {
  const K = window.KamOkA11y;
  if (!K) return;
  const { text, locale, nativeLanguage } = K;
  function ensureStyles() {
    if (document.getElementById('KamOkAccessibilityComplete')) return;
    const style = document.createElement('style');
    style.id = 'KamOkAccessibilityComplete';
    style.textContent = `
      .kamok-nav-item.has-dropdown.is-open > .kamok-dropdown,
      .kamok-nav-item.has-dropdown:focus-within > .kamok-dropdown { display: block; }
      .kamok-nav-item.has-dropdown.is-open > .kamok-nav-link .kamok-arrow,
      .kamok-nav-item.has-dropdown:focus-within > .kamok-nav-link .kamok-arrow { transform: rotate(180deg); opacity: 1; }
      .kamok-nav-link:focus-visible,
      .kamok-hamburger:focus-visible,
      .kamok-drawer a:focus-visible,
      .kamok-drawer button:focus-visible { outline: 3px solid #fff; outline-offset: 3px; box-shadow: 0 0 0 5px #17202a; }
      @media (max-width: 1024px) {
        .kamok-drawer { visibility: hidden; pointer-events: none; }
        .kamok-drawer.is-open { visibility: visible; pointer-events: auto; }
      }
      .kamok-sale-unit-note { margin: .55rem 0; font-size: 1.35rem; line-height: 1.45; color: rgba(var(--color-foreground), .82); }
      .card-wrapper .kamok-sale-unit-note, .cart-item .kamok-sale-unit-note { font-size: 1.2rem; margin: .35rem 0; }
      @media (prefers-reduced-motion: reduce) {
        .kamok-drawer, .kamok-arrow, .media--hover-effect img { transition: none !important; scroll-behavior: auto !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function moveSkipLinkFirst() {
    const link = document.querySelector('.skip-to-content-link[href="#MainContent"]');
    if (link && document.body.firstElementChild !== link) document.body.prepend(link);
  }

  function localizeStaticParts() {
    const lang = locale();
    const labels = text();
    const nav = document.querySelector('.kamok-mega-nav');
    const drawer = document.getElementById('kamokDrawer');
    const hamburger = document.getElementById('kamokHamburger');
    const close = document.getElementById('kamokDrawerClose');
    const home = document.querySelector('.kamok-nav-link--home');

    nav?.setAttribute('aria-label', labels.nav);
    drawer?.setAttribute('aria-label', labels.mobileNav);
    hamburger?.setAttribute('aria-label', labels.openMenu);
    close?.setAttribute('aria-label', labels.closeMenu);
    home?.setAttribute('aria-label', labels.home);

    if (lang !== nativeLanguage) {
      nav?.setAttribute('lang', nativeLanguage);
      drawer?.setAttribute('lang', nativeLanguage);
      document.querySelectorAll('.kamok-shipping-notice').forEach((notice) => notice.setAttribute('lang', nativeLanguage));
    }

    document.querySelectorAll('.price > p').forEach((paragraph) => {
      if (/Kaina su PVM|VAT included|Cena zawiera VAT/i.test(paragraph.textContent || '')) {
        paragraph.textContent = labels.vat;
        paragraph.removeAttribute('lang');
      }
    });
  }

  function closeDesktopMenus(except = null) {
    document.querySelectorAll('.kamok-nav-item.has-dropdown.is-open').forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector(':scope > .kamok-nav-link')?.setAttribute('aria-expanded', 'false');
    });
  }

  function initDesktopMenu() {
    document.querySelectorAll('.kamok-nav-item.has-dropdown').forEach((item, index) => {
      if (item.dataset.kamokA11yDesktop === 'true') return;
      const trigger = item.querySelector(':scope > .kamok-nav-link');
      const dropdown = item.querySelector(':scope > .kamok-dropdown');
      if (!trigger || !dropdown) return;

      item.dataset.kamokA11yDesktop = 'true';
      dropdown.id ||= `kamok-desktop-menu-${index + 1}`;
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-controls', dropdown.id);
      trigger.setAttribute('aria-expanded', 'false');

      const setOpen = (open, moveFocus = false) => {
        closeDesktopMenus(open ? item : null);
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
        if (open && moveFocus) dropdown.querySelector('a[href], button:not([disabled])')?.focus();
      };

      trigger.addEventListener('click', (event) => {
        if (matchMedia('(max-width: 1024px)').matches) return;
        if (!item.classList.contains('is-open')) {
          event.preventDefault();
          setOpen(true);
        }
      });

      trigger.addEventListener('keydown', (event) => {
        if (matchMedia('(max-width: 1024px)').matches) return;
        if (event.key === ' ' || event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(true, event.key === 'ArrowDown');
        } else if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          trigger.focus();
        }
      });

      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          trigger.focus();
        }
      });

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setOpen(false);
      });
    });

    if (document.documentElement.dataset.kamokMenuOutside !== 'true') {
      document.documentElement.dataset.kamokMenuOutside = 'true';
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.kamok-nav-item.has-dropdown')) closeDesktopMenus();
      });
    }
  }

  function focusableElements(container) {
    return [...container.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',
    )].filter((element) => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null);
  }

  function initMobileMenu() {
    const hamburger = document.getElementById('kamokHamburger');
    const drawer = document.getElementById('kamokDrawer');
    const closeButton = document.getElementById('kamokDrawerClose');
    const overlay = document.getElementById('kamokOverlay');
    if (!hamburger || !drawer || !closeButton || !overlay || drawer.dataset.kamokA11yMobile === 'true') return;

    drawer.dataset.kamokA11yMobile = 'true';
    hamburger.setAttribute('aria-controls', drawer.id);
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.inert = true;
    let returnFocus = hamburger;

    const closeSubmenus = () => {
      drawer.querySelectorAll('.kamok-drawer-toggle').forEach((toggle) => {
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        const submenu = document.getElementById(toggle.getAttribute('aria-controls') || '');
        if (submenu) {
          submenu.classList.remove('is-open');
          submenu.hidden = true;
        }
      });
    };

    const openDrawer = () => {
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : hamburger;
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      hamburger.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      closeButton.focus();
    };

    const closeDrawer = (restoreFocus = true) => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      document.body.style.overflow = '';
      closeSubmenus();
      if (restoreFocus && returnFocus?.isConnected) returnFocus.focus();
    };

    const intercept = (element, handler) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        handler();
      }, true);
    };

    intercept(hamburger, openDrawer);
    intercept(closeButton, () => closeDrawer());
    intercept(overlay, () => closeDrawer());

    drawer.querySelectorAll('.kamok-drawer-toggle').forEach((toggle, index) => {
      const submenu = toggle.nextElementSibling;
      if (!submenu) return;
      submenu.id ||= `kamok-mobile-submenu-${index + 1}`;
      submenu.hidden = true;
      toggle.setAttribute('aria-controls', submenu.id);
      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
        closeSubmenus();
        if (shouldOpen) {
          toggle.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          submenu.hidden = false;
          submenu.classList.add('is-open');
        }
      }, true);
    });

    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const elements = focusableElements(drawer);
      if (!elements.length) return;
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, true);

    addEventListener('resize', () => {
      if (!matchMedia('(max-width: 1024px)').matches && drawer.classList.contains('is-open')) {
        closeDrawer(false);
      }
    });
  }


  Object.assign(K, { ensureStyles, moveSkipLinkFirst, localizeStaticParts, closeDesktopMenus, initDesktopMenu, focusableElements, initMobileMenu });
})();
